import { render, staticRenderFns } from "./WorkTaskEscalation.vue?vue&type=template&id=94229272"
import script from "./WorkTaskEscalation.vue?vue&type=script&lang=ts"
export * from "./WorkTaskEscalation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports